// src/pages/Reports/IssuanceReporting/shared/IssuancePlanSelect.tsx
// README.md mục 7 — dropdown chọn Kế hoạch phát hành dùng CHUNG cho toàn bộ 6 trang tab-nhóm của
// module IssuanceReporting (mọi báo cáo đều có filter theo kỳ phát hành). Nạp 1 lần lúc mount,
// đúng pattern src/pages/Reports/AgentDebtReport/index.tsx (getIssuancePlans({pageIndex:1,pageSize:200})).

import React, { useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import { toast } from 'react-toastify';

import { getIssuancePlans } from 'helpers/fakebackend_helper';
import { IssuancePlan } from 'pages/IssuancePlan/types';
import { getPaginatedPayload } from './formatters';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

interface IssuancePlanSelectProps {
  value: string;
  onChange: (value: string) => void;
  /** true = không có lựa chọn "Tất cả kế hoạch" (dùng cho báo cáo bắt buộc chọn 1 kỳ — RPT-002/015/016/017/018) */
  requireSelection?: boolean;
  disabled?: boolean;
  className?: string;
}

const IssuancePlanSelect: React.FC<IssuancePlanSelectProps> = ({
  value,
  onChange,
  requireSelection = false,
  disabled = false,
  className,
}) => {
  const [plans, setPlans] = useState<IssuancePlan[]>([]);

  useEffect(() => {
    getIssuancePlans({ pageIndex: 1, pageSize: 200 })
      .then((res) => setPlans(getPaginatedPayload(res).items as IssuancePlan[]))
      .catch(() => toast.error(st('khong_the_tai_danh_sach_ke_message')));
  }, []);

  return (
    <Input
      type="select"
      className={className || 'form-select'}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value="">{requireSelection ? st('chon_ky_phat_hanh_text') : st('tat_ca_ky_phat_hanh_text')}</option>
      {plans.map((plan) => (
        <option key={plan.id} value={plan.id}>
          {plan.planCode}
        </option>
      ))}
    </Input>
  );
};

export default IssuancePlanSelect;
